var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel-slide',{class:[_vm.baseCss, ("overflow-" + _vm.overflow)],attrs:{"role":"tabpanel"}},[_c('div',{class:[_vm.$parent.paddingOff ? null : _vm.$parent.vertical ? ['px-2'] : ['p-2'], 'text-sm']},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-275aa676","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/tab-panel/tab-panel.vue
// module id = null
// module chunks = 